import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks";

import { NORESULTS_REC_ID } from "../config"

export default function NoResults() {
    const { response: { query }, pageType } = useAppState()

    useEffect(() => {
        if(!window.nostojs || pageType === 'category') return;
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ NORESULTS_REC_ID ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, []);

    return (
        <div class="text-center">
            <h5 class="ns-font-4" role="status">
                No results found for "{query}"
            </h5>
            <div class="nosto-rec-container">
                {pageType === 'search' &&
                    <div class="nosto_element" id={NORESULTS_REC_ID} />
                }
            </div>
        </div>
    )
}
